import React from 'react';
import Pages from './basic_page';
class  Notebook extends Pages {
    render() {
        return (
    <>
        <h1 className='des_note'>
            Notebook
        </h1>
        <div className='pageholder'>
            <div className='leftmenu'>
                <div>Notebook</div>
                <button onClick={() => this.scroll(this.firstRef)}>Protocol</button>
                <button onClick={() => this.scroll(this.secondRef)}>Notebook</button>
			</div>
            
            <div className='righttext'>
                <div className='P1' ref={this.firstRef}>
					<div className='text_wrap'>
                        <h3>Protocol</h3>
                        <a href='https://static.igem.wiki/teams/4298/wiki/protocol.pdf' >click to download Protocol.pdf</a>
					</div>
				</div>
				<div className='P2' ref={this.secondRef}>
				<div className='text_wrap'>
                    <h3 >Notebook</h3>
                    <h6>3-27 </h6>
                    <p>Project overview, project design, experimental process design and selection of appropriate models. </p >
                    <h6>4-3 </h6>
                    <p>HP was designed and implemented, teachers and doctors were contacted for communication, and science popularization was prepared. </p >
                    <p>The experiment and modeling design were improved, literature research was conducted and relevant experts were consulted to obtain the first batch of sample data. </p >
                    <h6>4-10 </h6>
                    <p>Conduct literature research and consult relevant experts, formulate plans for the whole project process and formulate alternative plans in advance. </p >
                    <h6>4-17 </h6>
                    <p>Introduce and discuss the current project plan, discuss the existing problems, and further improve the plan. </p >
                    <h6>4-24 </h6>
                    <p>Conduct registration and specific division of labor to determine the specific steps of the experiment. </p >
                    <p>Plasmids expressing AcrB were obtained, and AcrB-Empty plasmids were obtained by PCR and Gibson assembly. </p >
                    <p>The plasmids were introduced into E. coli to get the cloned strains with AcrB and AcrB-Empty plasmids. </p >
                    <h6>5-1 </h6>
                    <p>The cloned strains were sequenced. </p >
                    <p>Sequencing results showed that the target sequence was expressed in the bacteria. </p >
                    <p>Two strains of E. coli were tested for antibiotic resistance. </p >
                    <h6>5-8 </h6>
                    <p>Did not achieve the desired results. </p >
                    <p>The culture conditions were changed to continue testing both strains of E. coli for antibiotic resistance. </p >
                    <h6>5-15 </h6>
                    <p>Did not achieve the desired results. </p >
                    <p>E. coli with high AcrB expression did not work as we expected. </p >
                    <p>We did not continue to construct strains with high expression of AcrB, but used Escherichia coli containing AcrB-Empty as the object of our experiment. </p >
                    <h6>5-22 </h6>
                    <p>Start synthesizing TM1 and TM8. </p >
                    <p>The construction of co-culture system was started. </p >
                    <p>Orthorep system and secretory system were constructed, and Plasmid pITR-EPI was constructed by ITR backbone. </p >
                    <h6>5-29 </h6>
                    <p>The synthesis of TM1 and TM8 was successful, and the peptide function verification experiment was basically completed. </p >
                    <p>Construct the pITR-EPI plasmid. </p >
                    <p>Construct the co-culture system. </p >
                    <h6>6-5 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>Construct the pITR-EPI plasmid. </p >
                    <h6>6-12 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>Construct the pITR-EPI plasmid. </p >
                    <h6> 6-19 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>Construct the pITR-EPI plasmid. </p >
                    <h6>6-26 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>The pITR-EPI plasmid construction consistently failed, which we discovered was due to the use of garbage Gibson reagent. </p >
                    <p>The pITR-EPI plasmid was constructed by replacing Gibson reagent. </p >
                    <h6>7-3 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>Construct the pITR-EPI plasmid. </p >
                    <h6>7-10 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>The pITR-EPI plasmid was successfully constructed. </p >
                    <p>The pITR-EPI plasmid was transformed into the competent state of TOP10 E. coli.</p>
                    <h6>7-17 </h6>
                    <p>Construct the co-culture system. </p >
                    <p>Using colony PCR screening, no positive results were obtained. </p >
                    <p>We speculate that one possibility is that Gibson assembly is not efficient enough and there is no efficient screening method. Another possibility is that the presence of inverted repeats makes Gibson assembly difficult. </p >
                    <p>Consult literature and ask relevant experts to find solutions. </p >
                    <h6>7-24 </h6>
                    <p>The co-culture system was successfully constructed. </p >
                    <p>For Orthorep system, the NEBridge Golden Gate Assembly Tool was used to assist the design of primers, the Golden Gate assembly was used to assemble, and DH5alpha and DH10beta receptive states were tried to improve the conversion efficiency. Continue to construct the pITR-EPI plasmid. </p >
                    <p>The EvolvR system was started and assembled using Gibson assembly to construct the pEVR-EPI and pLXR-EPI plasmids. </p >
                    <h6>8-7 </h6>
                    <p>Continue to construct the pITR-EPI plasmid. </p >
                    <p>Construct the pEVR-EPI and pLXR-EPI plasmids. </p >
                    <h6>8-14 </h6>
                    <p>The plasmid pITR-EPI failed to construct and was reconstructed. </p >
                    <p>Construct the pEVR-EPI and pLXR-EPI plasmids. </p >
                    <h6>8-21 </h6>
                    <p>Continue to construct the pITR-EPI plasmid. </p >
                    <p>The pEVR-EPI and pLXR-EPI plasmids were constructed successfully. </p >
                    <p>The plasmids pEVR-EPI and pLXR-EPI were transformed into the competent state of TOP10 E. coli. </p >
                    <p>Positive clones were obtained by colony PCR screening. </p >
                    <h6>8-28 </h6>
                    <p>For pITR-EPI plasmid, no positive clones were obtained. </p >
                    <p>For the secretion system, Leu2 plasmid was used as backbone and Gibson assembly was used to construct pLeu2-α-GFP plasmid. </p >
                    <p>The cloned strains transfected into pEVR-EPI and pLXR-EPI plasmids were sequenced. </p >
                    <p>Plasmids containing the Cas9 system were found to have varying degrees of sequence loss. It is analyzed that Cas9 system is toxic to bacteria, so there will be different degrees of loss. </p >
                    <h6>9-4 </h6>
                    <p>Construct pLeu2-α-GFP plasmid. </p > 
                    <p>Reconstructed the pLXR-EPI plasmid. </p >
                    <h6>9-11 </h6>
                    <p>pLXR-EPI plasmid was constructed successfully. </p >
                    <p>pLeu2-α-GFP plasmid was constructed successfully. </p >
                    <p>The constructed plasmid was transformed into yeast. </p >
                    <p>Colony PCR was performed to screen positive clones. </p >
                    <h6>9-18 </h6>
                    <p>Positive clones were successfully obtained for pEVR-EPI and pLXR-EPI. </p >
                    <p>For pLeu2-α-GFP, the expected positive results were not obtained. Instead, it was examined under fluorescence microscope, screened rapidly, and further verified by colony PCR. </p >
                    <p>The EvolvR system was verified by co-culture. </p >
                    <h6>9-25 </h6>
                    <p>The yeast transformed into pLeu2-α-GFP plasmid was successfully obtained. </p >
                    <p>The EvolvR system was verified by co-culture. </p >
                    <p>Verify the secretory system. </p >
                    <h6>10-2 </h6>
                    <p>The EvolvR system was verified by co-culture. </p >
                    <p>Verify the secretory system. </p >
                    <h6>10-10 </h6>
                    <p>The EvolvR system was verified by co-culture. </p >
                    <p>Verify the secretory system. </p >

				</div>
                </div>
            </div>
		</div>
    </>

  );
    }
};

export default Notebook;

